// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"76":"common","636":"adyen","962":"paypal","988":"stripe"}[chunkId] + "-" + {"76":"ba1aa0998eac630949f3","636":"3300f402102a327a23e8","962":"4ca3d9de2c12bdf24ff3","988":"e34e7f28c4f44b5844f9"}[chunkId] + ".js";
};